import React, { createContext, useContext, useEffect, useState } from "react";
import { api, refreshSession } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState(() => localStorage.getItem("cit_mode") || "sender");
  const [modeChosen, setModeChosen] = useState(() => !!localStorage.getItem("cit_mode"));

  useEffect(() => {
    // Reopening the app: renew silently from the long-lived session cookie — never a login screen.
    const boot = async () => {
      if (!localStorage.getItem("cit_token")) await refreshSession();
      const r = await api.get("/auth/me");
      setUser(r.data);
      if (!localStorage.getItem("cit_mode") && r.data.last_mode) {
        setMode(r.data.last_mode); setModeChosen(true); localStorage.setItem("cit_mode", r.data.last_mode);
      }
    };
    const t0 = localStorage.getItem("cit_token");
    boot().catch(() => { if (localStorage.getItem("cit_token") === t0) localStorage.removeItem("cit_token"); })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, u) => {
    localStorage.setItem("cit_token", token);
    setUser(u);
    if (u?.last_mode) { setMode(u.last_mode); setModeChosen(true); localStorage.setItem("cit_mode", u.last_mode); }
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* already ended */ }
    localStorage.removeItem("cit_token");
    localStorage.removeItem("cit_mode");
    setModeChosen(false);
    setUser(null);
  };
  const switchMode = (m) => {
    setMode(m);
    setModeChosen(true);
    localStorage.setItem("cit_mode", m);
    api.patch("/users/me", { last_mode: m }).catch(() => {});
  };
  const refresh = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, mode, modeChosen, switchMode, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
